import React from "react"
import { Link, graphql } from "gatsby"
import { NavigationYamlNavigation } from "../../types/graphql-types"

interface Renderer {
  (item: NavigationYamlNavigation): JSX.Element
}

interface NavigationListData {
  data: Array<NavigationYamlNavigation>
  className?: string
  liClassName?: string
  renderItem?: Renderer
}

export const NavigationList: React.FC<NavigationListData> = ({
  data,
  className = "flex flex-wrap",
  liClassName = "",
  renderItem = item => item.label,
}) => (
  <ul class={className}>
    {data
      .filter(x => x.visibility === "visible")
      .sort((a, b) => a?.order - b?.order)
      .map(item => (
        <li key={item.href} class={liClassName}>
          {renderItem(item)}
        </li>
      ))}
  </ul>
)

export const query = graphql`
  fragment Navigation on NavigationYaml {
    navigation {
      href
      label
      linktype
      order
      visibility
    }
  }
`

interface LinkItemData {
  item: NavigationYamlNavigation
  className?: string
  activeClassName?: string
  itemRenderer?: React.FC<NavigationYamlNavigation>
  target?: string
}

export const LinkItem: React.FC<LinkItemData> = ({
  item,
  className = "",
  activeClassName = "",
  itemRenderer = item => item.label,
  target = "_blank",
}) =>
  item.linktype === "internal" ? (
    <Link class={className} to={item?.href} activeClassName={activeClassName}>
      {itemRenderer(item)}
    </Link>
  ) : (
    <a class={className} href={item?.href} target={target}>
      {itemRenderer(item)}
    </a>
  )

/*
interface NavigationBarData extends NavigationListData {
  linkItemClass?: String
  activeLinkItemClass?: String
}

const Navbar: React.FC<NavigationBarData> = ({}) => <NavigationList />
*/
